import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import Header1 from '../../../components/headers/header1';
import {Column, Row} from '../../../components/layout';
import colors from '../../../util/colors';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import CoveragesList from '../../coverages/components/CoveragesList';
import {CoveragesItem} from '../../coverages/Coverages';
import * as fonts from '../../../util/fonts';
import {LoadingOutlined} from '@ant-design/icons';
import attachfiles from '../../../assets/attach-files.svg';

import './styles.scss';
import AppDownloadButton from '../../../components/app-download-button';
import NewCoverageDetails from '../../coverages/components/NewCoverageDetails';
import {get} from '../../../api/api';
import {uriGetDeducts} from '../../../api/endpoints';

interface MyCoveragesProps {
  labels: typeof strings.pt.myCoverages;
  selectedBu: any;
  availableBus: any[];
  coveragesList: any[];
  isLoading: boolean;
  buStyles: any;
  busFuncMap: any;
}

function MyCoverages({
  labels,
  coveragesList,
  isLoading,
  buStyles,
  selectedBu,
  busFuncMap,
}: MyCoveragesProps) {
  const [selectedItem, setSelectedItem] = useState<CoveragesItem | any>({});
  const [showModal, setShowModal] = useState(false);
  const [errorFetchingDetail, setErrorFetchingDetail] = useState(false);
  const [coverageDetails, setCoverageDetails] = useState([]);
  const [deducts, setDeducts] = useState();
  const [listType, setListType] = useState(
    labels?.listType || strings.pt.myCoverages.listType
  );
  const [pdfUrl, setPdfUrl] = useState(
    labels?.pdfUrl || strings.pt.myCoverages.pdfUrl
  );

  const featureName = 'MyCoverages';

  useEffect(() => {
    get(uriGetDeducts(selectedBu.buId), false, 0, featureName).then(
      (resp: any) => {
        setDeducts(resp?.data?.items);
      }
    );
  }, [selectedBu.buId]);

  useEffect(() => {
    const coveragesStrings: any = busFuncMap[selectedBu.buId].find(
      (el: any) => el.featureTemplateAlias === functionalitiesAliasMap.coverages
    );
    if (coveragesStrings) {
      const listTypeString = coveragesStrings.labels?.find(
        (label: any) => label.labelTemplateAlias === 'listType'
      );
      const pdfUrlString = coveragesStrings.labels?.find(
        (label: any) => label.labelTemplateAlias === 'pdfUrl'
      );
      setListType(listTypeString.text || strings.pt.myCoverages.listType);
      setPdfUrl(pdfUrlString.text || strings.pt.myCoverages.pdfUrl);
    }
  }, [selectedBu.buId]);

  return (
    <>
      <Column className="my-coverages-container">
        <Header1
          style={{...fonts.Bold, ...fonts.XL, color: colors.black}}
          className="my-coverages-header">
          {labels?.covers}
        </Header1>
        <div className="my-coverages-body">
          <Row className="my-coverages-text-row">{labels?.recentCoverages}</Row>
          {isLoading ? (
            <LoadingOutlined style={{fontSize: 24, marginTop: '50px'}} spin />
          ) : (
            <Column>
              {listType === 'PDF' ? (
                <a
                  target="_blank"
                  href={pdfUrl}
                  className="anchor m-0 border-bottom-grey">
                  <Row className="reimbursement-success-file no-margin no-border">
                    <img className="irs-declaration-icon" src={attachfiles} />
                    <Column
                      className="reimbursement-success-file-title"
                      style={{...fonts.M, ...fonts.Medium}}>
                      {labels?.myCovers}
                    </Column>
                    <AppDownloadButton
                      color={buStyles?.primaryColor || colors.blue}
                    />
                  </Row>
                </a>
              ) : (
                <CoveragesList
                  coveragesList={coveragesList}
                  setCoverageDetails={setCoverageDetails}
                  setSelectedItem={setSelectedItem}
                  setShowModal={setShowModal}
                  setErrorFetchingDetail={setErrorFetchingDetail}
                />
              )}
            </Column>
          )}
        </div>

        <div>
          <NewCoverageDetails
            details={coverageDetails}
            showModal={showModal}
            setShowModal={setShowModal}
            selectedItem={selectedItem}
            deducts={deducts}
            errorFetchingDetail={errorFetchingDetail}
            setErrorFetchingDetail={setErrorFetchingDetail}
          />
        </div>
      </Column>
    </>
  );
}

const mapStateToProps = ({
  strings,
  selectedBu,
  availableBus,
  globalStyles,
  busFuncMap,
}: any) => ({
  labels: strings.value.pt.myCoverages,
  selectedBu: selectedBu.value,
  availableBus: availableBus.value,
  buStyles: globalStyles.value,
  busFuncMap: busFuncMap.value,
});

export default compose(connect(mapStateToProps)(MyCoverages));
